import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainPipe } from './contain.pipe';
import { ContainService } from './contain.service';

@NgModule({
  declarations: [ContainPipe],
  exports: [ContainPipe],
  imports: [
    CommonModule
  ],
  providers: [ContainService]
})
export class ContainModule { }
